var CustomCountdown = class extends HTMLElement {
  constructor() {
    super();
    this.intervalId = null;
  }

  connectedCallback() {
    // 1) Einstellungen aus den Attributen lesen
    const endDate = this.getAttribute("end-date") || "2025-12-31";
    const endTime = this.getAttribute("end-time") || "23:59:59";

    // Wir setzen voraus, dass Enddatum und Endzeit im Format YYYY-MM-DD und HH:MM:SS kommen
    // Kombinieren zu einer ISO-ähnlichen Zeichenkette
    // Hinweis: Ohne explizite Zeitzone interpretiert der Browser das Datum i.d.R. als lokale Zeit
    const endDateTime = new Date(`${endDate}T${endTime}`);

    // 2) Anzeige-Element erstellen
    const display = document.createElement("span");
    display.className = "countdown-display";
    this.appendChild(display);

    // 3) Update-Funktion für den Countdown
    const updateCountdown = () => {
      const now = new Date();
      const distance = endDateTime - now;

      if (distance <= 0) {
        // Countdown abgelaufen
        display.textContent = "";
        document.querySelector(".countdown-section").style.display = "none";
        if (this.intervalId) clearInterval(this.intervalId);
        return;
      }

      // Berechnung in Tage, Stunden, Minuten, Sekunden
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      const countdownElement = this.buildCountdownElement(
        days,
        hours,
        minutes,
        seconds
      );

      display.innerHTML = "";
      display.appendChild(countdownElement);
    };

    // 4) Direkt initial einmal aufrufen
    updateCountdown();

    // 5) Jede Sekunde aktualisieren
    this.intervalId = setInterval(updateCountdown, 1000);
  }

  buildCountdownElement(days, hours, minutes, seconds) {
    const fragment = new DocumentFragment();
    if (days > 0) {
      fragment.appendChild(
        this.createTimeElement(`${days} T `, "countdown-days")
      );
    }
    fragment.appendChild(this.createTimeElement(hours, "countdown-hours"));
    fragment.appendChild(
      this.createTimeElement(":", "countdown-separator", true)
    );
    fragment.appendChild(this.createTimeElement(minutes, "countdown-minutes"));
    fragment.appendChild(
      this.createTimeElement(":", "countdown-separator", true)
    );
    fragment.appendChild(this.createTimeElement(seconds, "countdown-seconds"));

    return fragment;
  }

  createTimeElement(value, className, isSeparator = false) {
    const span = document.createElement("span");
    span.className = className;
    // Wenn es kein Separator ist, formatieren wir den Wert (z. B. "01", "09", "12")
    // Andernfalls geben wir den Wert unverändert aus (z. B. ":")
    span.textContent = isSeparator ? value : String(value).padStart(2, "0");
    return span;
  }

  disconnectedCallback() {
    // Falls das Element entfernt wird, Intervall räumen
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
};

window.customElements.define("custom-countdown", CustomCountdown);

// Globaler Lock-Status
const cartProgressBarState = {
  isUpdating: false,
  updateQueue: Promise.resolve(),
  lastUpdateTime: 0,
};

var CartProgressBar = class extends HTMLElement {
  constructor() {
    super();
    this.initializeElements();
    this.setupObserver();
  }

  initializeElements() {
    this.freeProductId = document.querySelector(
      ".free-product__container"
    )?.dataset.product;
    this.total = 0;
    this.fetching = false;
    this.cartWrapper = document.querySelector("#cart-drawer");
    this.lineItems = document.querySelectorAll("line-item.line-item");
    this.progress = document.querySelector(".progress-bar__progress");
    this.progressBarGoals = document.querySelectorAll(".progress-bar__goal");
    this.progressBarGoalElement = document.querySelector(
      ".progress-bar__info .metafield-rich_text_field p"
    );
  }

  setupObserver() {
    const observer = new MutationObserver((mutations) => {
      // Prüfe, ob die Mutation relevant ist (z.B. nur Änderungen an line-items)
      const isRelevantChange = mutations.some((mutation) => {
        return Array.from(mutation.addedNodes).some(
          (node) =>
            node.nodeType === Node.ELEMENT_NODE &&
            (node.matches("line-item") || node.querySelector("line-item"))
        );
      });

      if (isRelevantChange) {
        setTimeout(() => {
          this.queueUpdate();
        }, 1500);
      }
    });

    observer.observe(this.cartWrapper, {
      childList: true,
      subtree: true,
    });
    this.queueUpdate();
  }

  queueUpdate() {
    const now = Date.now();
    // Verhindere zu häufige Updates (mindestens 1 Sekunde zwischen Updates)
    if (now - cartProgressBarState.lastUpdateTime < 1000) {
      return;
    }

    cartProgressBarState.updateQueue = cartProgressBarState.updateQueue
      .then(() => {
        if (!cartProgressBarState.isUpdating) {
          cartProgressBarState.lastUpdateTime = now;
          return this._updateProgressBar();
        }
      })
      .catch((error) => {
        console.error("Fehler beim Update des Warenkorbs:", error);
        cartProgressBarState.isUpdating = false;
      });
  }

  async _updateProgressBar() {
    if (cartProgressBarState.isUpdating) {
      return;
    }

    try {
      cartProgressBarState.isUpdating = true;

      this.total = Number(
        document.querySelector("cart-progress-bar")?.dataset?.total
      );

      this.goals = Array.from(
        document.querySelectorAll(".progress-bar__goal")
      ).map((goal) => {
        return {
          goal: Number(goal.dataset.goal),
          id: goal.dataset.product,
        };
      });

      this.lineItems = document.querySelectorAll("line-item.line-item");

      this.itemsInCart = Array.from(this.lineItems).map((lineItem) => {
        return {
          id: lineItem.dataset.id,
          quantity: Number(lineItem.dataset.quantity),
          price: Number(lineItem.dataset.price),
          line: lineItem.dataset.line,
        };
      });

      this.nonFreeProducts = Array.from(this.itemsInCart).filter((lineItem) => {
        return Number(lineItem.price) > 0;
      });

      this.freeProducts = Array.from(this.itemsInCart).filter((lineItem) => {
        return Number(lineItem.price) === 0;
      });

      this.freeProductsButTooMuch = Array.from(this.itemsInCart).filter(
        (lineItem) => {
          return this.goals.some((pos) => {
            return pos.id === lineItem.id && lineItem.quantity > 1;
          });
        }
      );

      this.illegalGifts = Array.from(this.itemsInCart).filter((lineItem) => {
        return this.goals.some((pos) => {
          return pos.id === lineItem.id && pos.goal > this.total;
        });
      });

      this.removeFromCartProducts = [...this.illegalGifts].filter((el) => el);

      this.addToCartProducts = this.goals.filter((goal) => {
        return (
          goal.goal < this.total &&
          !this.itemsInCart.some((lineItem) => goal.id === lineItem.id) &&
          goal.id !== "FREESHIPPING"
        );
      });

      let refresh = false;
      console.log(
        "debug",
        this.removeFromCartProducts,
        this.freeProductsButTooMuch,
        this.addToCartProducts
      );

      if (this.freeProductsButTooMuch.length > 0) {
        await this._changeCartById(this.freeProductsButTooMuch[0], 1);
        refresh = true;
      }
      if (this.removeFromCartProducts.length > 0) {
        await this._changeCartById(this.removeFromCartProducts[0], 0);
        refresh = true;
      }

      if (this.addToCartProducts.length > 0 && !this.isFetching) {
        await this._addToCart(this.addToCartProducts);
        refresh = true;
      }

      if (this.progress) {
        this.progress.style.width = `${
          this.total / 100 > 100 ? 100 : this.total / 100
        }%`;
      }

      const progressBadge = document.querySelector(".progress-bar__badge");
      if (progressBadge) {
        progressBadge.style.left = `calc(${
          this.total / 100 > 100 ? 100 : this.total / 100
        }% - 48px)`;
      }

      Array.from(document.querySelectorAll(".progress-bar__goal")).map(
        (goalElement) => {
          goalElement.dataset.goal <= this.total
            ? goalElement.classList.add("active")
            : goalElement.classList.remove("active");
          for (let goal of this.progressBarGoals) {
            const restGoal = goal.goal_eur - this.total;

            if (progressBadge) {
              if (restGoal < 0) {
                progressBadge.style.display = "none";
              } else {
                progressBadge.style.display = "inline-block";
              }

              if (this.total <= goal.goal_eur) {
                if (progressBadge.querySelector(".money")) {
                  progressBadge.querySelector(
                    ".money"
                  ).textContent = `€${Number(restGoal / 100)
                    .toFixed(2)
                    .replace(".", ",")}`;
                }
              }
            }
          }
        }
      );

      if (refresh) {
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:refresh", {
            bubbles: true,
          })
        );
      }
    } catch (error) {
      console.error("Fehler beim Update des Warenkorbs:", error);
    } finally {
      cartProgressBarState.isUpdating = false;
    }
  }

  async _changeCart(product, quantity) {
    let formData = {
      line: product.line,
      quantity,
    };
    return await fetch(window.Shopify.routes.root + "cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
  }

  async _changeCartById(product, quantity) {
    let formData = {
      id: product.id,
      quantity,
    };
    return await fetch(window.Shopify.routes.root + "cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
  }

  async _addToCart(newLineItems) {
    let formData = {
      items: [
        ...newLineItems.map((p) => {
          return { id: p.id, quantity: 1 };
        }),
      ],
    };
    this.isFetching = true;
    return await fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
  }
};

window.customElements.define("cart-progress-bar", CartProgressBar);

// SC Start Gender Switcher
window.SC_selectedGender = "man";
window.SC_gender_filter_init = false;
window.SC_applyProductGalleryFilters = function (
  gender = window.SC_selectedGender,
  mediaId = null
) {
  const GenderResults = document.querySelectorAll("[data-gender-result]");
  GenderResults.forEach((gender_res) => {
    const row_res = gender_res.dataset.genderResult;
    const json_res = JSON.parse(row_res);
    gender_res.innerHTML = json_res[window.SC_selectedGender];
  });

  const gallery = document.querySelector("product-gallery");
  const carousel = gallery?.querySelector("media-carousel");
  if (!carousel) return;

  const slides = Array.from(carousel.children);

  const filteredIndexes = slides
    .map((slide, index) => {
      const genderAttr = slide
        .getAttribute("data-media-gender")
        ?.trim()
        ?.toLowerCase();
      let genderMatch = true;
      if (window.SC_gender_filter_init) {
        genderMatch = genderAttr === gender;
      }

      return genderMatch ? null : index;
    })
    .filter((i) => i !== null);

  console.log("[SC_applyProductGalleryFilters] Gender:", gender);
  console.log("[SC_applyProductGalleryFilters] Hide indexes:", filteredIndexes);

  carousel.dispatchEvent(
    new CustomEvent("carousel:filter", {
      bubbles: true,
      detail: { filteredIndexes },
    })
  );

  document
    .querySelectorAll(`page-dots[aria-controls="${carousel.id}"]`)
    .forEach((dotGroup) => {
      dotGroup.dispatchEvent(
        new CustomEvent("control:filter", {
          bubbles: true,
          detail: { filteredIndexes },
        })
      );
    });

  let targetIndex = mediaId
    ? slides.findIndex(
        (slide) => parseInt(slide.getAttribute("data-media-id")) === mediaId
      )
    : -1;

  if (targetIndex === -1 || filteredIndexes.includes(targetIndex)) {
    targetIndex = slides.findIndex((_, i) => !filteredIndexes.includes(i));
  }

  if (targetIndex !== -1) {
    console.log(
      "[SC_applyProductGalleryFilters] Selecting slide index:",
      targetIndex
    );
    carousel.select?.(targetIndex);
  }
};
//SC Start

class SCGenderFilter extends HTMLElement {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    window.SC_gender_filter_init = true;
    this.buttons = this.querySelectorAll("button[data-gender]");
    this.buttons.forEach((btn) =>
      btn.addEventListener("click", this.handleClick)
    );

    const initialActive = this.querySelector(
      "button[data-gender='" + window.SC_selectedGender + "']"
    );
    if (initialActive) initialActive.classList.add("active");

    this.applyFilterFromUI();
  }

  disconnectedCallback() {
    this.buttons.forEach((btn) =>
      btn.removeEventListener("click", this.handleClick)
    );
  }

  handleClick(event) {
    event.preventDefault();
    this.buttons.forEach((btn) => btn.classList.remove("active"));
    event.currentTarget.classList.add("active");
    window.SC_selectedGender =
      event.currentTarget.dataset.gender?.toLowerCase() || "man";
    this.applyFilterFromUI();
  }

  applyFilterFromUI() {
    const gender = window.SC_selectedGender || "man";

    const variant = JSON.parse(
      document.querySelector("script[data-variant]")?.textContent || "{}"
    );

    const mediaId = variant?.featured_media?.id || null;

    console.log(
      "[SCGenderFilter] Applying filter: gender =",
      gender,
      "mediaId =",
      mediaId
    );
    window.SC_applyProductGalleryFilters?.(gender, mediaId);
  }
}

window.customElements.define("sc-gender-filter", SCGenderFilter);

// SC End
